import React, { useState } from 'react';
import { Button, Image, Modal, Text } from '@asigna/kit';
import { ConnectWalletModal } from 'components';

// TODO_R: [RCC] [FRS]
export const ConnectWalletPage = () => {
  const [connectModalOpen, setConnectModalOpen] = useState(false);

  return (
    <section className="h-screen w-full flex flex-col items-center justify-center">
      <div className="flex flex-col items-center justify-center gap-20">
        <Image className="mb-4" size={104} src="./stx.png" alt="Welcome to Asigna" />
        <Text message="Welcome to Asigna" size="r24" color="white" />
        <Text
          message="Connect your Stacks Wallet to proceed"
          size="r14"
          color="regular"
          className="mb-20"
        />
        <Button
          colorType="primary"
          onClick={() => setConnectModalOpen(true)}
          message="Connect wallet"
          className="min-w-[280px] mb-80"
        />
      </div>
      <Modal onClose={() => setConnectModalOpen(false)} isShow={connectModalOpen}>
        <ConnectWalletModal open={connectModalOpen} onClose={() => setConnectModalOpen(false)} />
      </Modal>
    </section>
  );
};
